import { memo } from 'react';
import { IconWrapper } from './IconWrapper';

export const MarkDoneIcon = memo(() => (
    <IconWrapper>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16">
            <path
                fill="currentColor"
                fillRule="evenodd"
                // eslint-disable-next-line max-len
                d="M8 1C4.1 1 1 4.1 1 8s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7Zm-1 9.7L4.5 8.2l.8-.8L7 9.1l3.7-3.7.8.8L7 10.7ZM2 8c0 3.3 2.7 6 6 6s6-2.7 6-6-2.7-6-6-6-6 2.7-6 6Z"
                clipRule="evenodd"
            />
        </svg>
    </IconWrapper>
));
